import { baseErrorResponseSchema, baseResponseSchema } from 'api/api.config';
import { z } from 'zod';

export const verifyMobileResponseSchema = baseResponseSchema.extend({});

export type VerifyMobileResponseIType = z.infer<
  typeof verifyMobileResponseSchema
>;

export const verifyMobileErrorResponseSchema = baseErrorResponseSchema;

export type VerifyMobileErrorResponseIType = z.infer<
  typeof verifyMobileErrorResponseSchema
>;

export const isVerifyMobileErrorResponse = (
  response: unknown,
): response is VerifyMobileErrorResponseIType => {
  return verifyMobileErrorResponseSchema.safeParse(response).success;
};
